import PropTypes from 'prop-types'
import { Table } from '@mui/material'

/**
 * StandardTable
 *
 * Centralizes common MUI table configuration so individual pages
 * don't have to duplicate header styling, stickyHeader, and cell padding.
 *
 * Admin list pages: see `docs/FRONTEND_PATTERNS.md` — typical stack is
 * AnimatedBox → PageHeader → ListFilterToolbar / FilterBar → loading/error/empty →
 * ScrollableTableContainer + StandardTable (+ RowActionMenu where needed).
 */
export const StandardTable = ({
  children,
  minWidth,
  size = 'small',
  stickyHeader = true,
  cellPaddingY = 1.25,
  headerCellFontWeight = 650,
  sx,
  ...rest
}) => {
  return (
    <Table
      size={size}
      stickyHeader={stickyHeader}
      sx={{
        minWidth,
        '& .MuiTableCell-root': { py: cellPaddingY },
        '& .MuiTableCell-head': { fontWeight: headerCellFontWeight },
        ...(sx || {}),
      }}
      {...rest}
    >
      {children}
    </Table>
  )
}

StandardTable.propTypes = {
  children: PropTypes.node.isRequired,
  minWidth: PropTypes.number,
  size: PropTypes.string,
  stickyHeader: PropTypes.bool,
  cellPaddingY: PropTypes.number,
  headerCellFontWeight: PropTypes.number,
  sx: PropTypes.object,
}

StandardTable.displayName = 'StandardTable'

